import type { FC, PropsWithChildren } from 'react'

import styled from '@emotion/styled'

import type { Asset } from 'contentful'

import { AppearanceProvider } from '@segment/matcha/foundations/AppearanceContext'

import ButtonText from '@segment/matcha/components/ButtonText'
import { ChevronRightIcon } from '@segment/matcha/components/Icons/Common'
import Image from '@segment/matcha/components/Image'

import PropCardBase, * as PropCard from '@segment/matcha/recipes/PropCard'

interface PropCardCtaProps {
  heading: string
  paragraph: string
  buttonText: string
  buttonUrl: string
  image: Asset
}

const PropCardCta: FC<PropsWithChildren<PropCardCtaProps>> = ({ heading, paragraph, buttonText, buttonUrl, image }) => {
  const { file } = image.fields

  return (
    <AppearanceProvider appearance="twilioLight">
      <Wrapper>
        <PropCardBase>
          <PropCard.Copy>
            <PropCard.Title>{heading}</PropCard.Title>
            <PropCard.Text>{paragraph}</PropCard.Text>
            <ButtonText size="medium" tag="a" href={buttonUrl} iconEnd={ChevronRightIcon}>
              {buttonText}
            </ButtonText>
          </PropCard.Copy>
          <PropCard.Img>
            <Picture
              src={file.url}
              alt={file.fileName}
              width={file.details.image?.width}
              height={file.details.image?.height}
            />
          </PropCard.Img>
        </PropCardBase>
      </Wrapper>
    </AppearanceProvider>
  )
}

const Wrapper = styled.div`
  margin: 30px 0;
`

interface PictureProps {
  src: string
  alt: string
  width?: number
  height?: number
}

const Picture: FC<PropsWithChildren<PictureProps>> = ({ src, alt, width, height }) => {
  return (
    <picture>
      <Image width={width} height={height} src={src} alt={alt} loading="lazy" />
    </picture>
  )
}

export default PropCardCta
